import React from 'react';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import { FaOptionIcon, help } from '@europrocurement/l2d-icons';
import { useTheme } from '@mui/system';
import SearchIcon from '@mui/icons-material/Search';
import { FlexyTextField } from '../../atoms/FlexyTextField';

export type ChoiceListSearchProps = {
    title: string;
    description: string;
    placeholderLabelSearch?: string;
    searchValue: string;
    setSearchValue: (value: string) => void;
};

export const ChoiceListSearch: React.FunctionComponent<ChoiceListSearchProps> = function ({
    title,
    description,
    placeholderLabelSearch,
    searchValue,
    setSearchValue,
}) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <Typography
                className="title"
                variant="l2dh4"
                sx={{
                    color: theme.palette.primary.text,
                }}
            >
                {title}
            </Typography>
            {description !== '' ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        fontSize: '18px',
                        marginTop: '15px',
                        marginBottom: '15px',
                    }}
                >
                    <Typography
                        variant="l2dlabel"
                        color="text.secondary"
                    >
                        <FaOptionIcon
                            {...help.props}
                            color="text.secondary"
                        />
                    </Typography>

                    <Box
                        fontSize="14px"
                        marginLeft="8px"
                    >
                        <Typography
                            variant="l2dlabel"
                            color="text.secondary"
                        >
                            {description}
                        </Typography>
                    </Box>
                </Box>
            ) : null}
            <Box sx={{ width: '100%', marginTop: '20px', marginBottom: '10px' }}>
                <FlexyTextField
                    className="search"
                    variant="outlined"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder={placeholderLabelSearch || 'Rechercher'}
                    sx={{ width: '100%' }}
                    inputMode="search"
                    InputProps={{
                        sx: {
                            borderRadius: '12px',
                            backgroundColor: theme.palette.background.paper,
                        },
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconButton>
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        </Box>
    );
};
